import { Checkbox, FormControl, FormControlLabel } from '@material-ui/core';
import PropTypes from 'prop-types';
import { Component } from 'react';

import styles from './CustomCheckbox.scss';
const rootClassName = styles.rootClassName;

class CustomCheckbox extends Component {
  render() {
    let checkboxClassName = this.props.className
      ? this.props.className + ' ' + rootClassName
      : rootClassName;
    checkboxClassName = this.props.error
      ? checkboxClassName + ' ' + rootClassName + '-error'
      : checkboxClassName;
    const allCheckboxProps = {
      onChange: (event) => {
        const newEvent = {
          ...event,
          target: {
            ...event.target,
            name: this.props.name,
            value: event.target.checked,
          },
        };
        this.props.onChange(newEvent);
      },
      checked: this.props.checked || false,
      className: checkboxClassName,
    };
    let allProps = {
      ...this.props,
      className: this.props.className
        ? this.props.className + ' ' + rootClassName + '-form-control'
        : rootClassName + '-form-control',
    };
    const allFormControlLabelProps = {
      className:
        rootClassName +
        '-form-control-label ' +
        (this.props.error ? rootClassName + '-form-control-label-error' : ''),
    };
    delete allProps.onChange;
    delete allProps.checked;
    delete allProps.label;
    return (
      <FormControl {...allProps}>
        <FormControlLabel
          {...allFormControlLabelProps}
          label={this.props.label}
          control={<Checkbox {...allCheckboxProps} />}
        />
        {this.props.children}
      </FormControl>
    );
  }
}

CustomCheckbox.propTypes = {
  ...FormControl.propTypes,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
};

export default CustomCheckbox;
